
import { db } from '../firebase';
import { 
    collection, 
    query, 
    where, 
    orderBy, 
    onSnapshot, 
    updateDoc, 
    doc, 
    writeBatch,
} from 'firebase/firestore';
import { AppNotification } from '../types';

export const NotificationService = {
    /**
     * Subscribes to notifications for a specific user and organization.
     */
    listenToNotifications(userId: string, orgId: string, callback: (notifs: AppNotification[]) => void) {
        const q = query(
            collection(db, 'notifications'),
            where('recipientId', '==', userId),
            where('orgId', '==', orgId),
            orderBy('createdAt', 'desc')
        );

        return onSnapshot(q, (snapshot) => {
            callback(snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            } as AppNotification)));
        });
    },

    async markAsRead(id: string) {
        try {
            await updateDoc(doc(db, 'notifications', id), { isRead: true });
        } catch (e) {
            console.error("Failed to mark notification as read", e);
            throw e;
        }
    },

    async markAllAsRead(notifications: AppNotification[]) {
        const batch = writeBatch(db);
        notifications.filter(n => !n.isRead).forEach(n => {
            batch.update(doc(db, 'notifications', n.id), { isRead: true });
        });
        await batch.commit();
    },

    async clearAll(notifications: AppNotification[]) {
        const batch = writeBatch(db);
        notifications.forEach(n => {
            batch.delete(doc(db, 'notifications', n.id));
        });
        await batch.commit();
    }
};
